import { ReactElement, useEffect, useRef, useState } from 'react';
import ReactModal from 'react-modal';

type BallparkRegistrationDialogProps = {
    isOpen: boolean;
    onCancel: () => void;
    onContinue: (firstName: string, lastName: string) => void;
};

export function BallparkRegistrationDialog(props: BallparkRegistrationDialogProps): ReactElement {
    const [firstName, setFirstName] = useState('');
    const [lastName, setLastName] = useState('');

    const firstNameRef = useRef<HTMLInputElement>(null);

    const isFormValid = () => {
        return firstName.trim().length > 0 && lastName.trim().length > 0;
    };

    useEffect(() => {
        if (props.isOpen) {
            setTimeout(() => {
                firstNameRef.current?.focus();
            }, 100);
        }
    }, [props.isOpen]);

    return (
        <ReactModal
            isOpen={props.isOpen}
            contentLabel="Ballpark Registration"
            ariaHideApp={false}
            style={modalStyles}
            shouldCloseOnOverlayClick={false}
            className={'ballpark-registration ballpark-registration-modal-content'}
        >
            <div className="modal-dialog">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title">Almost there ⚾</h5>
                    </div>
                    <div className="modal-body">
                        <div className="mt-2" style={{ fontSize: '14px' }}>
                            <div>
                                We need some more information so we can create your Los Angeles Angels ticket account.
                            </div>
                        </div>

                        <div className="my-3">
                            <input
                                type="text"
                                className="form-control"
                                placeholder="First Name"
                                autoComplete="given-name"
                                value={firstName}
                                ref={firstNameRef}
                                onChange={(e) => setFirstName(e.target.value)}
                            />
                        </div>

                        <div className="my-3">
                            <input
                                type="text"
                                className="form-control"
                                placeholder="Last Name"
                                autoComplete="family-name"
                                value={lastName}
                                onChange={(e) => setLastName(e.target.value)}
                            />
                        </div>
                    </div>
                    <div className="modal-footer px-0">
                        <div className="row">
                            <div className="col-12 pl-0 text-right pt-3">
                                <button
                                    type="button"
                                    onClick={props.onCancel}
                                    className="btn btn-secondary text-uppercase mr-2"
                                    data-dismiss="modal"
                                >
                                    Cancel
                                </button>
                                <button
                                    type="button"
                                    onClick={() => props.onContinue(firstName, lastName)}
                                    disabled={!isFormValid()}
                                    className="btn btn-primary text-uppercase"
                                >
                                    Continue
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </ReactModal>
    );
}

const modalStyles = {
    overlay: {
        backgroundColor: 'rgba(0,0,0,.7)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    content: {
        outline: 'none',
    },
};
